import { useMemo, useState } from "react";
import { Button } from "antd";
import type { MembershipProduct, SpaceProfile } from "../SpaceType";
import { listBundlesContainingProduct } from "../spacePageUtils";
import { SpaceProductPurchaseModal } from "./SpaceProductPurchaseModal";
import { BundlePlanPickerModal } from "./BundlePlanPickerModal";
import { StandaloneProductPurchaseModal } from "../../../standalone/purchase/StandaloneProductPurchaseModal";

export function BundlePlanPurchaseActions(props: {
  spaceId: string;
  row: MembershipProduct;
  membershipProducts: MembershipProduct[];
  isLoggedIn: boolean;
  onLoginRequest: () => void;
  spaceProfile: SpaceProfile | null;
  variant: "platform" | "standalone";
}): JSX.Element | null {
  const {
    spaceId,
    row,
    membershipProducts,
    isLoggedIn,
    onLoginRequest,
    spaceProfile,
    variant,
  } = props;
  const bundles = useMemo(
    () => listBundlesContainingProduct(membershipProducts, row.spaceProductId),
    [membershipProducts, row.spaceProductId]
  );
  const [pickerOpen, setPickerOpen] = useState(false);
  const [bundlePurchase, setBundlePurchase] = useState<MembershipProduct | null>(null);

  if (bundles.length === 0) {
    return null;
  }

  const openBundlePurchase = (bundle: MembershipProduct) => {
    if (!isLoggedIn) {
      onLoginRequest();
      return;
    }
    setPickerOpen(false);
    setBundlePurchase(bundle);
  };

  const onPlanPurchaseClick = () => {
    if (!isLoggedIn) {
      onLoginRequest();
      return;
    }
    if (bundles.length === 1) {
      setBundlePurchase(bundles[0]);
      return;
    }
    setPickerOpen(true);
  };

  return (
    <>
      <Button
        type="primary"
        className="space-access-gate__bundle-plan-btn"
        onClick={onPlanPurchaseClick}
      >
        套餐购买
      </Button>
      <BundlePlanPickerModal
        open={pickerOpen}
        bundles={bundles}
        spaceId={spaceId}
        isLoggedIn={isLoggedIn}
        onLoginRequest={onLoginRequest}
        spaceProfile={spaceProfile}
        onClose={() => setPickerOpen(false)}
        onPickBundle={openBundlePurchase}
      />
      {variant === "platform" && bundlePurchase ? (
        <SpaceProductPurchaseModal
          spaceId={spaceId}
          row={bundlePurchase}
          open
          onClose={() => setBundlePurchase(null)}
          isLoggedIn={isLoggedIn}
          onLoginRequest={onLoginRequest}
          spaceProfile={spaceProfile}
        />
      ) : variant === "standalone" && bundlePurchase ? (
        <StandaloneProductPurchaseModal
          row={bundlePurchase}
          open
          onClose={() => setBundlePurchase(null)}
          isLoggedIn={isLoggedIn}
          onLoginRequest={onLoginRequest}
        />
      ) : null}
    </>
  );
}
